import { useState } from "react";
import { Play } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function Videos({ videos, eyebrow = "Em Vídeo", title, intro, sectionId = "videos" }) {
    const [active, setActive] = useState(videos[0]?.id);
    const [playing, setPlaying] = useState(false);

    if (!videos?.length) return null;
    const activeVideo = videos.find((v) => v.id === active) || videos[0];

    const selectVideo = (id) => {
        setActive(id);
        setPlaying(false);
    };

    return (
        <section id={sectionId} className="bg-forest-deep py-24 sm:py-32" data-testid="video-section">
            <div className="mx-auto max-w-5xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">{eyebrow}</p>
                    <h2 className="mt-3 font-serif text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        {title}
                    </h2>
                    {intro && <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-stone-300">{intro}</p>}
                </Reveal>

                <Reveal delay={0.15} className="mt-12">
                    <div className="overflow-hidden rounded-3xl border border-white/10 shadow-2xl shadow-black/40" data-testid="video-player">
                        {playing ? (
                            <iframe
                                src={`https://www.youtube-nocookie.com/embed/${activeVideo.id}?autoplay=1&rel=0`}
                                title={activeVideo.title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="aspect-video w-full"
                            />
                        ) : (
                            <button
                                type="button"
                                data-testid="video-play-button"
                                onClick={() => setPlaying(true)}
                                aria-label={`Assistir: ${activeVideo.title}`}
                                className="group relative block aspect-video w-full"
                            >
                                <img
                                    src={`https://i.ytimg.com/vi/${activeVideo.id}/hqdefault.jpg`}
                                    alt={activeVideo.title}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <span className="absolute inset-0 bg-black/35 transition-colors duration-300 group-hover:bg-black/20" />
                                <span className="absolute inset-0 flex items-center justify-center">
                                    <span className="flex h-20 w-20 items-center justify-center rounded-full bg-wa text-white shadow-2xl transition-transform duration-300 group-hover:scale-110">
                                        <Play className="ml-1 h-8 w-8 fill-current" />
                                    </span>
                                </span>
                                <span className="absolute bottom-5 left-5 right-5 text-left font-serif text-lg font-medium text-white drop-shadow-lg sm:text-xl">
                                    {activeVideo.title}
                                </span>
                            </button>
                        )}
                    </div>

                    {videos.length > 1 && (
                        <div className="mt-5 grid grid-cols-3 gap-3">
                            {videos.map((v) => (
                                <button
                                    key={v.id}
                                    type="button"
                                    data-testid={`video-thumb-${v.id}`}
                                    onClick={() => selectVideo(v.id)}
                                    className={`group relative overflow-hidden rounded-xl border-2 transition-all duration-200 ${
                                        active === v.id ? "border-gold" : "border-transparent opacity-70 hover:opacity-100"
                                    }`}
                                    aria-label={`Selecionar vídeo: ${v.title}`}
                                >
                                    <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt={v.title} loading="lazy" className="aspect-video w-full object-cover" />
                                    <span className="absolute inset-0 flex items-center justify-center bg-black/30">
                                        <Play className="h-6 w-6 fill-white text-white" />
                                    </span>
                                </button>
                            ))}
                        </div>
                    )}
                </Reveal>
            </div>
        </section>
    );
}
